import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';

export const HeaderRoot = styled(FlexBox)`
  width: 100%;
  align-items: flex-start;
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
`;

export const ImageContainer = styled.div`
  min-width: 270px;
  width: 270px;
  height: 270px;
  margin-right: 24px;
  position: relative;
  flex-shrink: 0;
  border-radius: 3px;
  overflow: hidden;
  background: ${Colors.galBlack5};

  @media (max-width: ${LayoutConst.screen.l}px) {
    max-width: 160px;
    max-height: 160px;
    min-width: 160px;
    min-height: 160px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    margin-right: 0;
    margin-bottom: 16px;
  }
`;

export const ImageMock = styled.div`
  width: 100%;
  height: 100%;
  background: ${Colors.galBlack10};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.galBlack47};
  font-family: Inter, sans-serif;
  font-size: 43px;
  font-weight: 600;
  line-height: 51px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const InfoColumn = styled(FlexBox)`
  flex: 1;
  min-width: 0;
  width: 100%;
  flex-flow: column;
  min-height: 270px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    min-height: auto;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 8px;
  row-gap: 4px;
`;

export const Title = styled(FInter.SectionTitle)`
  line-height: 51px;
  font-size: 43px;
  width: auto;
  max-width: 100%;
  color: ${({ theme }) => theme.designerPage?.textColor || Colors.galBlack100};

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const ProfileLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  color: var(--Gallllery-Black47, #909090);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  text-transform: lowercase;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;

  svg path {
    fill: currentColor;
  }

  &:hover {
    color: ${({ theme }) => theme.subscribeInfo?.hover || Colors.galBlack100};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const MetaRow = styled.div`
  color: ${({ theme }) => theme.subscribeInfo?.color || Colors.galBlack47};
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.02em;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  .personalized-tag-subscribe {
    color: var(--Gallllery-Black47, #909090);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter, sans-serif;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-transform: capitalize;

    .icon-with-text {
      color: var(--Gallllery-Black47, #909090);
      font-weight: 600;
      text-decoration-line: underline;
      text-transform: capitalize;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;

    .personalized-tag-subscribe {
      font-size: 13px;
      line-height: 16px;
    }
  }
`;

export const ClaimButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #909090;
  border-radius: 5px;
  padding: 5px 16px;
  background: transparent;
  cursor: pointer;
  text-decoration: none;
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.designerPage?.textColor || Colors.galBlack100};
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const CountryBlock = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.designerRoleUniversity || Colors.galBlack100};
  font-weight: 600;
  letter-spacing: -0.34px;
  padding-right: 8px;
  margin-right: 0;
  border-right: 1px solid ${({ theme }) => theme.designerRoleUniversity || Colors.galBlack100};
`;

export const CountryFlag = styled.img`
  width: 29px;
  height: 20px;
  border: 0.4px solid #b6b6b5;
  border-radius: 2px;
`;

export const Subscribers = styled.span`
  display: inline-flex;
  flex-direction: row;
  gap: 8px;
`;

export const ContactLink = styled(Link)`
  color: var(--Gallllery-Black47, #909090);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.subscribeInfo?.hover || Colors.galBlack100};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const Description = styled.div`
  margin-top: 16px;
  color: ${({ theme }) => theme.designerPage?.textColor || Colors.galBlack100};
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  white-space: pre-line;

  .show-more-button {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from 'core';

export const HeaderRoot = styled(FlexBox)`
  width: 100%;
  align-items: flex-start;
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
  }
`;

export const ImageContainer = styled.div`
  min-width: 270px;
  width: 270px;
  height: 270px;
  margin-right: 24px;
  position: relative;
  flex-shrink: 0;
  border-radius: 3px;
  overflow: hidden;
  background: ${Colors.galBlack5};

  @media (max-width: ${LayoutConst.screen.l}px) {
    max-width: 160px;
    max-height: 160px;
    min-width: 160px;
    min-height: 160px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    margin-right: 0;
    margin-bottom: 16px;
  }
`;

export const ImageMock = styled.div`
  width: 100%;
  height: 100%;
  background: ${Colors.galBlack10};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.galBlack47};
  font-family: Inter, sans-serif;
  font-size: 43px;
  font-weight: 600;
  line-height: 51px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const InfoColumn = styled(FlexBox)`
  flex: 1;
  min-width: 0;
  width: 100%;
  flex-flow: column;
  min-height: 270px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    min-height: auto;
  }
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 8px;
  row-gap: 4px;
`;

export const Title = styled(FInter.SectionTitle)`
  line-height: 51px;
  font-size: 43px;
  width: auto;
  max-width: 100%;
  color: ${({ theme }) => theme.designerPage?.textColor || Colors.galBlack100};

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 22px;
    line-height: 28px;
  }
`;

export const ProfileLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  color: var(--Gallllery-Black47, #909090);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  text-transform: lowercase;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;

  svg path {
    fill: currentColor;
  }

  &:hover {
    color: ${({ theme }) => theme.subscribeInfo?.hover || Colors.galBlack100};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const MetaRow = styled.div`
  color: ${({ theme }) => theme.subscribeInfo?.color || Colors.galBlack47};
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.02em;
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  .personalized-tag-subscribe {
    color: var(--Gallllery-Black47, #909090);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter, sans-serif;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.34px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-transform: capitalize;

    .icon-with-text {
      color: var(--Gallllery-Black47, #909090);
      font-weight: 600;
      text-decoration-line: underline;
      text-transform: capitalize;
    }
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;

    .personalized-tag-subscribe {
      font-size: 13px;
      line-height: 16px;
    }
  }
`;

export const ClaimButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #909090;
  border-radius: 5px;
  padding: 5px 16px;
  background: transparent;
  cursor: pointer;
  text-decoration: none;
  font-family: Inter, sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.designerPage?.textColor || Colors.galBlack100};
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const CountryBlock = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.designerRoleUniversity || Colors.galBlack100};
  font-weight: 600;
  letter-spacing: -0.34px;
  padding-right: 8px;
  margin-right: 0;
  border-right: 1px solid ${({ theme }) => theme.designerRoleUniversity || Colors.galBlack100};
`;

export const CountryFlag = styled.img`
  width: 29px;
  height: 20px;
  border: 0.4px solid #b6b6b5;
  border-radius: 2px;
`;

export const Subscribers = styled.span`
  display: inline-flex;
  flex-direction: row;
  gap: 8px;
`;

export const ContactLink = styled(Link)`
  color: var(--Gallllery-Black47, #909090);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter, sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.subscribeInfo?.hover || Colors.galBlack100};
  }

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-size: 13px;
    line-height: 16px;
  }
`;

export const Description = styled.div`
  margin-top: 16px;
  color: ${({ theme }) => theme.designerPage?.textColor || Colors.galBlack100};
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  white-space: pre-line;

  .show-more-button {
    padding-left: 0;
    padding-right: 0;
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;
